import { render, staticRenderFns } from "./PlayerQtt.vue?vue&type=template&id=20eb24a4&scoped=true&"
import script from "./PlayerQtt.vue?vue&type=script&lang=js&"
export * from "./PlayerQtt.vue?vue&type=script&lang=js&"
import style0 from "./PlayerQtt.vue?vue&type=style&index=0&id=20eb24a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb24a4",
  null
  
)

export default component.exports